import { cva } from 'class-variance-authority'

// Styles for the CheckboxPrimitive.Root
export const checkboxStyles = cva(
  `
  peer
  h-[1rem]
  w-[1rem]
  shrink-0
  rounded-sm
  border
  border-primary
  shadow
  focus-visible:outline-none
  focus-visible:ring-1
  focus-visible:ring-ring
  disabled:cursor-not-allowed
  disabled:opacity-50
  data-[state=checked]:bg-primary
  data-[state=checked]:text-primary-foreground
`
)

// Styles for the CheckboxPrimitive.Indicator
export const checkboxIndicatorStyles = cva(
  `
    flex
    items-center
    justify-center
    text-current
    w-full
    h-full
  `
)

export const labelStyles = cva(
  `
    text-sm
    font-normal
    text-neutral-600
    peer-data-[state=checked]:font-medium
    peer-data-[state=checked]:text-neutral-900
  `,
  {
    variants: {
      disabled: {
        true: 'text-neutral-400 peer-data-[state=checked]:text-neutral-400',
      },
    },
    defaultVariants: {
      disabled: false,
    },
  }
)
